module.exports = __webpack_public_path__ + "img/back02.bc11a20c.png";